import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const MaintenanceChart = () => {
  const data = [
    { month: 'Jan', scheduled: 12, completed: 8, pending: 4 },
    { month: 'Feb', scheduled: 15, completed: 10, pending: 5 },
    { month: 'Mar', scheduled: 18, completed: 14, pending: 4 },
    { month: 'Apr', scheduled: 22, completed: 18, pending: 4 },
    { month: 'May', scheduled: 25, completed: 20, pending: 5 },
    { month: 'Jun', scheduled: 28, completed: 22, pending: 6 },
    { month: 'Jul', scheduled: 32, completed: 26, pending: 6 },
    { month: 'Aug', scheduled: 35, completed: 28, pending: 7 },
    { month: 'Sep', scheduled: 30, completed: 24, pending: 6 },
    { month: 'Oct', scheduled: 27, completed: 22, pending: 5 },
    { month: 'Nov', scheduled: 24, completed: 20, pending: 4 },
    { month: 'Dec', scheduled: 20, completed: 16, pending: 4 },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
          <p className="font-medium text-gray-900 dark:text-white">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="h-80">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" opacity={0.2} />
          <XAxis 
            dataKey="month" 
            stroke="#9CA3AF"
            fontSize={12}
          />
          <YAxis 
            stroke="#9CA3AF"
            fontSize={12}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Area
            type="monotone"
            dataKey="scheduled"
            stackId="1"
            stroke="#3B82F6"
            fill="#3B82F6"
            fillOpacity={0.2}
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="completed"
            stackId="1"
            stroke="#10B981"
            fill="#10B981"
            fillOpacity={0.2}
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="pending"
            stackId="1"
            stroke="#F59E0B"
            fill="#F59E0B"
            fillOpacity={0.2}
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MaintenanceChart;